import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudButtonModule, FreudDialogModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { CalendarRecurrencyAttemptModalComponent } from './calendar-recurrency-attempt-modal.component';

@NgModule({
	declarations: [CalendarRecurrencyAttemptModalComponent],
	imports: [
		CommonModule,
		FreudDialogModule,
		TranslateModule,
		FreudButtonModule,
	],
	exports: [CalendarRecurrencyAttemptModalComponent],
	providers: [],
})
export class CalendarRecurrencyAttemptModalModule {}
